// extracted by mini-css-extract-plugin
export var founder = "founder-module--founder--a6c0b";
export var founder__colFirst = "founder-module--founder__col--first--a1ccc";
export var founder__colSecond = "founder-module--founder__col--second--fd4b3";
export var founder__img = "founder-module--founder__img--51b81";
export var founder__row = "founder-module--founder__row--3fa8c";
export var founder__text = "founder-module--founder__text--bd0d0";
export var founder__textFirst = "founder-module--founder__text--first--963ad";
export var founder__title = "founder-module--founder__title--b8ebd";
export var founder__wrapper = "founder-module--founder__wrapper--ae6c1";